import { useEffect, useRef } from 'react';
import { initAnalytics, track } from '@/lib/analytics';

let hqAnalyticsReady = false;

export function ensureHqAnalytics(): void {
  if (hqAnalyticsReady) return;
  initAnalytics();
  hqAnalyticsReady = true;
}

export function trackHq(eventName: string, extra?: Record<string, unknown>): void {
  track(eventName, {
    host: 'coparentinghq.com',
    seo_category: 'hq',
    ...extra,
  });
}

export function useHqScreenEvent(
  eventName: string,
  extra?: Record<string, unknown>,
): void {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    trackHq(eventName, extra);
    // Screen events fire once per mount; extra is only used on first paint.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName]);
}
